/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSquad.vue?vue&type=template&id=6df5de37&scoped=true"
import script from "./popSquad.vue?vue&type=script&lang=js"
export * from "./popSquad.vue?vue&type=script&lang=js"
import style0 from "./popSquad.vue?vue&type=style&index=0&id=6df5de37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5de37",
  null
  
)

export default component.exports